









import { Component, Vue } from 'vue-property-decorator'
import EditShares from '@/views/Company/Settings/Shares/EditShares.vue'
import EditSharesLegacy from '@/views/Company/Settings/Shares/EditSharesLegacy.vue'
import ModuleIframe from '@/components/ui/ModuleIframe.vue'

@Component({
    components: {
        ModuleIframe,
        EditShares,
        EditSharesLegacy,
    },
})
export default class SharesList extends Vue {}
